import React, { useState } from "react";
import { Col, Row, Form, Input, Radio, DatePicker } from "antd";
import { removeMask } from "../../../helper/mask";
import moment from "moment";
import services from "../services";
import InputCPF from "./Input-CPF";
import { diffDateInYear } from "../../../helper/util";

import ModalHistorico from "../modalHistorico";
import BloqueioJuntaMedica from "../../../component/BloqueioJuntaMedica/bloqueioJuntaMedica";

import { Popover,message } from "antd";
import BloqueioProvaDeVida from "../../../component/BloqueioProvaDeVida/bloqueioProvaDeVida";

const YEAR_REQUER_REPRESENTANTE = 16;

const formatarData = (valor) => (valor ? moment(valor, "YYYY-MM-DD") : null);

const mapPessoa = ({ pais = "BRASIL", nascimento, ...rest }) => ({
  ...rest,
  pais,
  nascimento: formatarData(nascimento),
});

const mapRepresentanteLegal = ({ pessoa, tokenDocumento, ...rest }) => ({
  ...rest,
  pessoa: mapPessoa(pessoa),
  tokenDocumento,
  arquivo: tokenDocumento
    ? [
        {
          uid: "-1",
          name: "Comprovante Representante Legal.pdf",
          type: "application/pdf",
          status: "done",
          token: tokenDocumento,
        },
      ]
    : undefined,
});

const mapCertidao = (
  { livro = "", folha = "", ...certidao },
  certidaoToken
) => ({
  ...certidao,
  livro: `${livro}`,
  folha: `${folha}`,
  certidaoToken,
  arquivo: certidaoToken
    ? [
        {
          uid: "-1",
          name: "Comprovante Certidão.pdf",
          type: "application/pdf",
          status: "done",
          token: certidaoToken,
        },
      ]
    : undefined,
});

const criarPessoaVazia = () => {
  return {
    nome: "",
    sexo: "",
    nascimento: "",
    pais: "BRASIL",
    cep: "",
    logradouro: "",
    complemento: "",
    uf: "",
    cidade: "",
    bairro: "",
    telefone1: "",
  };
};

const IdentificacaoPessoa = ({
  form,
  nome,
  camposAdicionais = true,
  desabilitarCampos = true,
  desabilitarCPF = false,
  ocultarCampos = false,
  ocultarEtapa2,
  ocultarEtapa3,
  handleValoresCPF,
  pesquisarRepresentante = false,
  onClear,
  onHandleRequerRepresentante,
  onRetificar,
  recadastramento,
  emissaoDeclaracao,
  setEmissaoDeclaracao,

}) => {

  const permiteContato = Form.useWatch(["pessoa", "autorizaContato"], form);

  const [mostrarModalHistorico, setMostrarModalHistorico] =
    React.useState(false);

  const [valoresForm, setValoresForm] = React.useState({});

  const [mostrarBloqueio, setMostrarBloqueio] = useState(false);
const [mensagemBloqueio, setMensagemBloqueio] = useState("");

const [mostrarBloqueioProvaDeVida, setMostrarBloqueioProvaDeVida] = useState(false);
const [mensagemBloqueioProvaDeVida, setMensagemBloqueioProvaDeVida] = useState("");
    

  /*const carregarCPF = (valor) => {
    const cpf = removeMask(valor);
    if (cpf && cpf.length === 11) {
      if (!pesquisarRepresentante) {
        services
          .obterCPF(cpf)
          .then((result) => result.data)
          .then((dados) =>
            IdentificacaoPessoa.processarDados(dados, handleValoresCPF)
          );
      } else {
        services
          .obterRepresentante(cpf)
          .then((result) => result.data)
          .then((dados) => {
            dados.nascimento = formatarData(dados.nascimento);
            handleValoresCPF({ ...criarPessoaVazia(), ...dados });
          });
      }
    }
  };*/

  const carregarCPF = (valor) => {
    const cpf = removeMask(valor);
  
    if (!cpf || cpf.length !== 11) return;
  
    const tratarErro = (error) => {
      const data = error.response?.data;
      let mensagem = "Erro ao buscar CPF.";

      if (data?.codigo === "BLOQUEIO_JUNTA_MEDICA") {
        setMensagemBloqueio(data.mensagem);
        setMostrarBloqueio(true);
        return;
      }

      if (data?.codigo === "BLOQUEIO_PROVA_DE_VIDA") {
        setMensagemBloqueioProvaDeVida(data.mensagem);
        setMostrarBloqueioProvaDeVida(true);
        return;
      }

      message.error(
        data?.mensagem || "Erro ao buscar CPF.",
        4
      );
  
    };
  
    if (!pesquisarRepresentante) {
      services
        .obterCPF(cpf)
        .then((result) => result.data)
        .then((dados) =>
          IdentificacaoPessoa.processarDados(dados, handleValoresCPF)
        )
        .catch((error) => {
          tratarErro(error);
          return Promise.resolve();
        });
    } else {
      services
        .obterRepresentante(cpf)
        .then((result) => result.data)
        .then((dados) => {
          dados.nascimento = formatarData(dados.nascimento);
          handleValoresCPF({ ...criarPessoaVazia(), ...dados });
        })
        .catch((error) => {
          tratarErro(error);
          return Promise.resolve();
        });
    }
  };
  

  const handlePesquisarCPF = (valor) => {
    carregarCPF(valor);
  };

  const handleControleRepresentante = (valor) => {
    if (camposAdicionais) {
      return onHandleRequerRepresentante(
        IdentificacaoPessoa.checandoDiferencaEntreDatas(valor)
      );
    }
  };

  const imprimirDeclaResponsabilidade = () => {
    const formValues = form.getFieldsValue(true);

    const params = {
      permiteContato: formValues.pessoa?.autorizaContato,
      cpf:formValues?.[nome]?.cpf,
    };
    try {
      const response =  services.getDeclaResponbilidade(params);
      setEmissaoDeclaracao(true); 
    
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Row>
        <Col span={4}>
          <Form.Item
            name={[nome, "cpf"]}
            label="CPF"
            rules={[{ required: true }, { validator: InputCPF.Validator }]}
          >
            <InputCPF
              onSearch={handlePesquisarCPF}
              onClear={onClear}
              readOnly={desabilitarCPF}
            />
          </Form.Item>
        </Col>
        <Col span={10} hidden={ocultarCampos}>
          <Form.Item
            name={[nome, "nome"]}
            label="Nome"
            rules={[{ required: true }]}
          >
            <Input disabled={desabilitarCampos} />
          </Form.Item>
        </Col>
        <Col span={6} hidden={ocultarCampos}>
          <Form.Item
            name={[nome, "sexo"]}
            label="Sexo"
            rules={[{ required: true }]}
          >
            <Radio.Group disabled={desabilitarCampos}>
              <Radio value="F">Feminino</Radio>
              <Radio value="M">Masculino</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={4} hidden={ocultarCampos}>
          <Form.Item
            name={[nome, "nascimento"]}
            label="Data de Nascimento"
            rules={[{ required: true }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              disabled={desabilitarCampos}
              onChange={handleControleRepresentante}
            />
          </Form.Item>
        </Col>
      </Row>
      {!(ocultarCampos || !camposAdicionais) && (
        <Row>
          <Col span={12}>
            <Form.Item
              name={[nome, "mae"]}
              label="Nome da Mãe"
              rules={[{ required: true }]}
            >
              <Input disabled={desabilitarCampos} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={[nome, "pai"]}
              label="Nome do Pai"
              rules={[{ required: true }]}
            >
              <Input disabled={desabilitarCampos} />
            </Form.Item>
          </Col>
        </Row>
      )}

      <Row hidden={ocultarCampos}>
        {/*<Col>
          <button
            type="button"
            className="btn btn-outline-dark mr-2"
            onClick={() => {
              onClear();
            }}
          >
            <i className="fa fa-eraser" />
              Limpar Busca
          </button>
        </Col>

        <Col>
                <button
                  type="button"
                  className="btn btn-outline-success mr-2"
                  onClick={() => setMostrarModalHistorico(true)}
                >
                  <i className="fa fa-search" />
                  Histórico
                </button>
        </Col>*/}

        {/*recadastramento && (
          <Col>
             <Popover
                content="A declaração será liberada após o preenchimento do campo de permissão para contato."
                trigger="hover"
                open={permiteContato == null ? undefined : false}
              >
                <span>
                  <button
                    type="button"
                    className="btn btn-outline-success mr-2 no-focus-outline"
                    onClick={imprimirDeclaResponsabilidade}
                    disabled={permiteContato == null}
                  >
                    <i className="fa fa-file-text-o mr-2" />
                    Declaração Responsabilidade
                  </button>
                </span>
              </Popover>
          </Col>
        )*/}
      </Row>

      {mostrarModalHistorico && (
          <ModalHistorico
            show
            close={() => setMostrarModalHistorico(false)}
            onRetificar={(id, anoReferencia) => {
              setMostrarModalHistorico(false);
              
              onRetificar(id, anoReferencia, form.getFieldValue([nome, "cpf"]));
            }}
            cpf={form.getFieldValue(["pessoa", "cpf"])}
            nome={form.getFieldValue(["pessoa", "nome"])}
          />
        )}

      <BloqueioJuntaMedica
        visivel={mostrarBloqueio}
        mensagem={mensagemBloqueio}
        onFechar={() => setMostrarBloqueio(false)}
      />

      <BloqueioProvaDeVida
        visivel={mostrarBloqueioProvaDeVida}
        mensagem={mensagemBloqueioProvaDeVida}
        onFechar={() => setMostrarBloqueioProvaDeVida(false)}
      />
    </>
  );
};

IdentificacaoPessoa.checandoDiferencaEntreDatas = (valor) =>
  diffDateInYear(moment(), valor) < YEAR_REQUER_REPRESENTANTE;
IdentificacaoPessoa.processarDados = (dados, handleValoresCPF) => {
  dados.pessoa = mapPessoa(dados.pessoa);
  if (dados.representanteLegal)
    dados.representanteLegal = mapRepresentanteLegal(dados.representanteLegal);
  if (dados.certidao)
    dados.certidao = mapCertidao(dados.certidao, dados.certidaoToken);
  if (!dados.certidao) dados["certidao"] = {};
  console.log(dados);
  handleValoresCPF(dados);
};

export default IdentificacaoPessoa;
